'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixJsSdk = require('matrix-js-sdk');

var _reactBeautifulDnd = require('react-beautiful-dnd');

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _FlairStore = require('../../../stores/FlairStore');

var _FlairStore2 = _interopRequireDefault(_FlairStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function nop() {} /*
                  Copyright 2017 Vector Creations Ltd
                  
                  Licensed under the Apache License, Version 2.0 (the "License");
                  you may not use this file except in compliance with the License.
                  You may obtain a copy of the License at
                  
                      http://www.apache.org/licenses/LICENSE-2.0
                  
                  Unless required by applicable law or agreed to in writing, software
                  distributed under the License is distributed on an "AS IS" BASIS,
                  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                  See the License for the specific language governing permissions and
                  limitations under the License.
                  */

var GroupTile = _react2.default.createClass({
    displayName: 'GroupTile',

    propTypes: {
        groupId: _propTypes2.default.string.isRequired,
        // Whether to show the short description of the group on the tile
        showDescription: _propTypes2.default.bool,
        // Height of the group avatar in pixels
        avatarHeight: _propTypes2.default.number
    },

    contextTypes: {
        matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
    },

    getInitialState: function getInitialState() {
        return {
            profile: null
        };
    },
    getDefaultProps: function getDefaultProps() {
        return {
            showDescription: true,
            avatarHeight: 50
        };
    },


    componentWillMount: function componentWillMount() {
        var _this = this;

        _FlairStore2.default.getGroupProfileCached(this.context.matrixClient, this.props.groupId).then(function (profile) {
            _this.setState({ profile: profile });
        }).catch(function (err) {
            console.error('Error whilst getting cached profile for GroupTile', err);
        });
    },

    onMouseDown: function onMouseDown(e) {
        e.preventDefault();
        _dispatcher2.default.dispatch({
            action: 'view_group',
            group_id: this.props.groupId
        });
    },

    render: function render() {
        var _this2 = this;

        var BaseAvatar = _index2.default.getComponent('avatars.BaseAvatar');
        var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
        var profile = this.state.profile || {};
        var name = profile.name || this.props.groupId;
        var avatarHeight = this.props.avatarHeight;
        var descElement = this.props.showDescription ? _react2.default.createElement(
            'div',
            { className: 'mx_GroupTile_desc' },
            profile.shortDescription
        ) : _react2.default.createElement('div', null);
        var httpUrl = profile.avatarUrl ? this.context.matrixClient.mxcUrlToHttp(profile.avatarUrl, avatarHeight, avatarHeight, "crop") : null;
        // XXX: Use onMouseDown as a workaround for https://github.com/atlassian/react-beautiful-dnd/issues/273
        // instead of onClick. Otherwise we experience https://github.com/vector-im/riot-web/issues/6156
        return _react2.default.createElement(
            AccessibleButton,
            { className: 'mx_GroupTile', onMouseDown: this.onMouseDown, onClick: nop },
            _react2.default.createElement(
                _reactBeautifulDnd.Droppable,
                { droppableId: 'my-groups-droppable', type: 'draggable-TagTile' },
                function (droppableProvided, droppableSnapshot) {
                    return _react2.default.createElement(
                        'div',
                        { ref: droppableProvided.innerRef },
                        _react2.default.createElement(
                            _reactBeautifulDnd.Draggable,
                            {
                                key: "GroupTile " + _this2.props.groupId,
                                draggableId: "GroupTile " + _this2.props.groupId,
                                index: _this2.props.groupId,
                                type: 'draggable-TagTile'
                            },
                            function (provided, snapshot) {
                                return _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                        'div',
                                        (0, _extends3.default)({
                                            ref: provided.innerRef
                                        }, provided.draggableProps, provided.dragHandleProps),
                                        _react2.default.createElement(
                                            'div',
                                            { className: 'mx_GroupTile_avatar' },
                                            _react2.default.createElement(BaseAvatar, {
                                                name: name,
                                                idName: _this2.props.groupId,
                                                url: httpUrl,
                                                width: avatarHeight,
                                                height: avatarHeight })
                                        )
                                    ),
                                    provided.placeholder ? _react2.default.createElement(
                                        'div',
                                        { className: 'mx_GroupTile_avatar' },
                                        _react2.default.createElement(BaseAvatar, {
                                            name: name,
                                            idName: _this2.props.groupId,
                                            url: httpUrl,
                                            width: avatarHeight,
                                            height: avatarHeight })
                                    ) : _react2.default.createElement('div', null)
                                );
                            }
                        )
                    );
                }
            ),
            _react2.default.createElement(
                'div',
                { className: 'mx_GroupTile_profile' },
                _react2.default.createElement(
                    'div',
                    { className: 'mx_GroupTile_name' },
                    name
                ),
                descElement,
                _react2.default.createElement(
                    'div',
                    { className: 'mx_GroupTile_groupId' },
                    this.props.groupId
                )
            )
        );
    }
});

exports.default = GroupTile;
module.exports = exports['default'];
//# sourceMappingURL=GroupTile.js.map